module.exports = __webpack_public_path__ + "assets/img/free_15.584c5acd.png";